import Api from '../Api';

import { url } from './config';
import { ServicePaidByOption } from './types';

const api = new Api<ServicePaidByOption>(url);

export default api;
